import { Button, CardContent, Tooltip } from "@mui/material";
import {
  BooleanField,
  Datagrid,
  DateInput,
  List,
  TextField,
  useTheme,
  WithRecord,
} from "react-admin";
import ReactJsonView from "@microlink/react-json-view";
import { green } from "@mui/material/colors";
import DownloadMenu from "../../Components/MLModels/DownloadMenu";
import { Verified, Warning } from "@mui/icons-material";

const dateParser = (v) => {
  if (v === undefined || v === "") return "";
  const dateParts = v.split("-");
  const date = new Date();
  date.setDate(dateParts[2]);
  date.setFullYear(dateParts[0]);
  date.setMonth(dateParts[1] - 1);
  const start = Date.parse(date.toDateString()) / 1000;
  return start + ".." + (start + 86400);
};
const formatParser = (v) => {
  if (v === undefined || v === "NaN..NaN") return "";
  const parts = v.split("..");
  const date = new Date(parts[0] * 1000);

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const postFilters = [
  <DateInput
    label="Date Run"
    source="dateRun[between]"
    key={"dateRun[between]"}
    alwaysOn={true}
    parse={dateParser}
    format={formatParser}
  />,
];

const ListMachineLearningModels = (props) => {
  const [theme] = useTheme();

  const postRowSx = (record) => {
    const isDarkMode = theme.palette.mode === "dark";
    const productionColour = isDarkMode ? green[900] : "#efe";
    return {
      backgroundColor: record.production === true ? productionColour : null,
    };
  };

  return (
    <CardContent>
      <List
        {...props}
        title="Machine Learning Models"
        filters={postFilters}
        actions={false}
        sort={{ field: "date_run", order: "DESC" }}
      >
        <Datagrid
          bulkActionButtons={false}
          optimized={true}
          rowStyle={postRowSx}
          sx={{
            textAlign: "center",
          }}
        >
          <BooleanField
            label="Prod"
            source="production"
            sortable={false}
            TrueIcon={Verified}
            FalseIcon={null}
            sx={{
              "& svg": {
                color: theme.palette.mode === "dark" ? "yellow" : "green",
                scale: "1.3",
              },
            }}
          />
          <TextField
            label="Country"
            source="country"
            sortable={false}
            sx={{ textTransform: "uppercase" }}
          />
          <TextField label="Model Type" source="modelType" sortable={false} />
          <TextField label="Training Date" source="dateRun" sortable={false} />
          <TextField
            label="Validation Score"
            source="validationScore"
            sortable={false}
          />
          <TextField
            label="Validation Mean"
            source="validationMean"
            sortable={false}
          />
          <TextField
            label="Transform Target"
            source="transformTarget"
            sortable={false}
          />
          <WithRecord
            label="Model Report"
            render={(record) => {
              const data = JSON.parse(record.modelBuilderReport);
              return (
                <ReactJsonView
                  src={data}
                  collapsed={true}
                  displayDataTypes={false}
                  name={false}
                  theme={
                    theme.palette.mode === "dark"
                      ? "summerfruit"
                      : "rjv-default"
                  }
                />
              );
            }}
          />
          <WithRecord
            label="Feature Report"
            render={(record) => {
              const data = JSON.parse(record.featureBuilderReport);
              return (
                <ReactJsonView
                  src={data}
                  name={false}
                  collapsed={true}
                  displayDataTypes={false}
                  theme={
                    theme.palette.mode === "dark"
                      ? "summerfruit"
                      : "rjv-default"
                  }
                />
              );
            }}
          />
          <WithRecord
            label="Downloads"
            render={(record) => {
              if (record.modelDownloadURLs.length === 0) {
                return (
                  <Tooltip title="We couldn't find the file in storage. Please try again later">
                    <span>
                      <Button
                        disabled={true}
                        color="warning"
                        fontWeight="bold"
                        startIcon={<Warning color="warning" />}
                      >
                        Error
                      </Button>
                    </span>
                  </Tooltip>
                );
              } else {
                return <DownloadMenu record={record} />;
              }
            }}
          />
          <style>{`.react-json-view .copy-to-clipboard-container {display: inline-block!important } .react-json-view {background-color: transparent!important}`}</style>
        </Datagrid>
      </List>
    </CardContent>
  );
};

export default ListMachineLearningModels;
